import React from 'react';
import SectionTabs from '../section-tabs/section-tabs';
import './main-section-header.scss';

const MainSectionHeader = ({
  title,
  tabs,
  activeTab,
  onTabClick,
  tabsClassName = '',
  className = '',
  action = null,
}) => {
  const hasToolbar = Boolean(action);
  const rootClassName = [
    'main-section-header',
    hasToolbar ? 'main-section-header--has-toolbar' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={rootClassName}>
      <div className="main-section-header__layout">
        <div className="main-section-header__main">
          {title ? <h2>{title}</h2> : null}
          <div className="main-section-header__tabs-row">
            <SectionTabs
              tabs={tabs}
              activeTab={activeTab}
              onTabClick={onTabClick}
              className={tabsClassName}
            />
          </div>
        </div>
        {hasToolbar ? (
          <div className="main-section-header__toolbar">
            {action ? <div className="main-section-header__action">{action}</div> : null}
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MainSectionHeader;
